import { application } from "./application"

import PaymentMethodsController from "./payment_methods_controller"
import PasswordVisibilityController from "./password_visibility_controller"
import UtilsController from "./utils_controller"
import PlanPeriodController from "./plan_period_controller"
import TagsController from "./tags_controller"

application.register("payment-methods", PaymentMethodsController)
application.register("password-visibility", PasswordVisibilityController)
application.register("utils", UtilsController)
application.register("plan-period", PlanPeriodController)
application.register("tags", TagsController)
